<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
  <div [innerHTML]="message"></div>
</mat-dialog-content>

<mat-dialog-actions >
  @if (transformationProtocols && transformationProtocols.length>0) {
    <div class="m-3 w-100 flex-col justify-center items-center">
      <mat-select placeholder="Select Field" required [(ngModel)]="selectedTransformationProtocol">
        @for (protocol of transformationProtocols; track protocol.id; let i = $index) {
          <mat-option [value]="protocol">
            {{protocol.outputFieldIndex+1}}: <span>{{protocol.outputFieldName}}</span>
          </mat-option>
        }
      </mat-select>
    </div>
  }
  <div class="mt-3 p-2 w-100 flex-row justify-end items-center">
    <a mat-button class="dialog-btn mr-5" color="primary" (click)="onCancelClick()" ><span class="text-bold">{{cancelButtonText}}</span></a>
    <a mat-button class="dialog-btn" color="primary" (click)="onConfirmClick()" [disabled]="!canClickConfirm"><span class="text-bold">{{confirmButtonText}}</span></a>
  </div>
</mat-dialog-actions>
